export function formatDate(iso: string, locale: string = "es-MX"): string {
  const d = new Date(iso);
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
}

export function formatShortDate(iso: string, locale: string = "es-MX"): string {
  const d = new Date(iso);
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
  }).format(d);
}

export function formatTime(iso: string, locale: string = "es-MX"): string {
  const d = new Date(iso);
  return new Intl.DateTimeFormat(locale, { hour: "2-digit", minute: "2-digit" }).format(d);
}

export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}

export function startOfMonth(now: Date = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth(), 1);
}

export function startOfWeek(now: Date = new Date()): Date {
  const d = new Date(now);
  const day = d.getDay();
  const diff = day === 0 ? 6 : day - 1; // lunes como inicio
  d.setDate(d.getDate() - diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isSameMonth(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
}

export function subtractMonths(now: Date, n: number): Date {
  return new Date(now.getFullYear(), now.getMonth() - n, now.getDate());
}

export function dayKey(iso: string): string {
  return iso.slice(0, 10);
}

export function monthLabel(date: Date, locale: string = "es-MX"): string {
  return new Intl.DateTimeFormat(locale, { month: "short" }).format(date);
}